import { HttpInterceptorFn } from '@angular/common/http';

const UNSAFE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

function readCookie(name: string): string | null {
	const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
	return match ? decodeURIComponent(match[1]) : null;
}

// Angular's built-in XSRF interceptor (HttpXsrfInterceptor) skips every request whose URL is
// absolute (http:// or https://) - it's designed for same-origin/relative-URL apps. This app's
// AjaxService always builds absolute URLs to the API's own origin/port, so the built-in
// interceptor would silently never attach the header. This hand-rolled version reads the same
// "XSRF-TOKEN" cookie the backend issues (via IAntiforgery, alongside the session cookies on
// login/refresh) and manually attaches it as X-XSRF-TOKEN on mutating requests.
export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
	if (!UNSAFE_METHODS.has(req.method)) {
		return next(req);
	}
	const token = readCookie('XSRF-TOKEN');
	if (!token) {
		return next(req);
	}
	return next(req.clone({ setHeaders: { 'X-XSRF-TOKEN': token } }));
};
